import Vue from 'vue';

const MAX_ENTRIES = 8;
const STORAGE_KEY = 'my247ed_recent_users';

const state = Vue.observable({
    users: []
    // Structure: [{ userId, firstName, lastName, openedBy, openedById, openedAt }]
});

// Load from localStorage on init
try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) state.users = JSON.parse(stored);
} catch (e) {}

function save() {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(state.users));
    } catch (e) {}
}

export function trackUserOpened(data) {
    // Remove existing entry for same user to move it to top
    state.users = state.users.filter(u => u.userId !== data.userId);

    state.users.unshift({
        userId: data.userId,
        firstName: data.firstName,
        lastName: data.lastName,
        openedBy: data.openedBy,
        openedById: data.openedById,
        openedAt: Date.now()
    });

    // Keep list trimmed
    if (state.users.length > MAX_ENTRIES) {
        state.users = state.users.slice(0, MAX_ENTRIES);
    }

    save();
}

export function getRecentUsers() {
    return state.users;
}

export default state;
